export default {
  default: {
    title: "I've read & accept the terms and conditions",
  },
}
